// extracted by mini-css-extract-plugin
module.exports = {"doc":"Doc-doc-a12d","frame":"Doc-frame-a12d","load":"Doc-load-a12d"};